export const START = 'UPLOAD_PROGRESS_ALERT/START';
export const SET = 'UPLOAD_PROGRESS_ALERT/SET';
export const END = 'UPLOAD_PROGRESS_ALERT/END';
export const SAVE_DISC = 'UPLOAD_PROGRESS_ALERT/SAVE_DISC';
